export const ACTION_CLIENTID = {
    SET_CLIENTIDACTIVED: 'SET_CLIENTIDACTIVED'
};
